import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { ReactComponent as Logo } from './logo.svg';
// import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FoodBankIcon from '@mui/icons-material/FoodBank';
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp';
import HowToRegSharpIcon from '@mui/icons-material/HowToRegSharp';
import SupervisorAccountSharpIcon from '@mui/icons-material/SupervisorAccountSharp';
import { useNavigate } from 'react-router-dom';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import { userContext } from '../../contexts/userContext';



const pages = ['CC Menu', 'CC Card', 'CC Org', 'Admin And Sales Accounts', 'Create Order'];
const settings = ['Logout'];

function AdminNav() {
  const navigate = useNavigate();
  const { userType } = useContext(userContext);
  console.log('userType', userType);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const logout = async () => {
    await localStorage.setItem("auth-token", "");
    // window.location.reload();
    navigate('/')
  };
  ;

  return (
    <AppBar className='main-navBar' position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} /> */}
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <Logo />
          </Typography>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              className='ul-menu-new'
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >

{(userType == 1 || userType == 4) && <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => { handleCloseNavMenu(); navigate('/AllResturent'); }}
              >
                <FoodBankIcon /> Menu Orders
              </Button>}
              {/* <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => { handleCloseNavMenu(); navigate('/AddResturent'); }}
              >
                <RestaurantIcon /> Add Restaurant
              </Button> */}
              {(userType == 1 || userType == 3) &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/CCFiles')}
              >
                <PictureAsPdfIcon /> CC Files
              </Button>
              }
             
              {(userType != 4) && <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/BasicCard')}
              >
                <CreditCardIcon /> CC Card
              </Button>}
              
              {(userType == 1 || userType == 3) &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/CompanyCard')}
              >
                <CreditCardIcon /> CC Org
              </Button>
              }
               {userType == 1 &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/adminAndSales')}
              >
                <SupervisorAccountSharpIcon /> Admin And Sales Accounts
              </Button>
              }
              {userType == 1 &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/chosetype')}
              >
                <AddCircleIcon /> Create Order
              </Button>
              }
            </Menu>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="#app-bar-with-responsive-menu"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <Logo />
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
          {(userType == 1 || userType == 4) && <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/AllResturent')}
              >
                <FoodBankIcon /> Menu Orders
              </Button>}
            {/* <Button
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={() => navigate('/AddResturent')}
            >
              <RestaurantIcon /> Add Restaurant
            </Button> */}
            {(userType == 1 || userType == 3) &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/CCFiles')}
              >
                <PictureAsPdfIcon /> CC Files
              </Button>}

              {(userType != 4) && <Button
              sx={{ my: 2, color: 'white', display: 'block' }}
              onClick={() => navigate('/BasicCard')}
            >
              <CreditCardIcon /> CC Card
            </Button>}

            {(userType == 1 || userType == 3) &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/CompanyCard')}
              >
                <CreditCardIcon /> CC Org
              </Button>}
            {userType == 1 &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/adminAndSales')}
              >
                <SupervisorAccountSharpIcon /> Admin And Sales Accounts
              </Button>}

            {userType == 1 &&
              <Button
                sx={{ my: 2, color: 'white', display: 'block' }}
                onClick={() => navigate('/chosetype')}
              >
                <AddCircleIcon /> Create Order
              </Button>
            }

          </Box>

          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography style={{ color: 'black' }} onClick={logout} textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AdminNav;